import { useFlightSearchDataContext } from "@/features/flights/contexts/FlightSearchDataContext";
import { useFlightSortContext } from "@/features/flights/contexts/FlightSortContext";
import { buildFlightSearchCriteria } from "@/features/flights/utils/buildFlightSearchCriteria";
import type { FlightSearchFormValues } from "@/features/flights/utils/flightsValidation";
import { usePreviousFlightSearchData } from "@/features/search/hooks/usePreviousSearchData";
import { FlightTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";

export const useFlightSearchForm = () => {
  const { setPreviousSearchData } = usePreviousFlightSearchData();
  const { resetSortValue } = useFlightSortContext();
  const { updateSearchData } = useFlightSearchDataContext();

  const handleSubmit = (values: FlightSearchFormValues) => {
    rudderAnalytics.track(
      FlightTrackingEvents.USER_SEARCHED_FOR_OFFERS,
      buildFlightSearchCriteria(values),
    );
    resetSortValue();
    setPreviousSearchData(values);
    updateSearchData(values);
  };

  return { handleSubmit };
};
